function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
/* eslint "class-methods-use-this": ["error", { "exceptMethods": ["bindEvents"] }] */
var ImageGallery = /*#__PURE__*/function () {
  function ImageGallery() {
    _classCallCheck(this, ImageGallery);
    this.bindEvents();
  }
  _createClass(ImageGallery, [{
    key: "bindEvents",
    value: function bindEvents() {
      var currentImage = document.getElementById('GalleryCurrent');
      var currentImageMob = document.getElementById('GalleryCurrentMob');
      var galleryThumbs = Array.from(document.querySelectorAll('.c-image-gallery__thumb'));
      var enlargeTrigger = document.getElementById('GalleryModalTrigger');
      var galleryText = document.querySelector('.c-image-gallery__text');
      if (galleryThumbs.length) {
        galleryThumbs.forEach(function (thumb) {
          var text = {
            code: thumb.dataset.code || false,
            size: thumb.dataset.size || false,
            length: thumb.dataset.length || false
          };
          thumb.addEventListener('click', function (e) {
            e.preventDefault();
            if (currentImage) {
              currentImage.srcset = thumb.dataset.imagesource;
            }
            if (currentImageMob) {
              currentImageMob.src = thumb.dataset.imagesource;
            }
            if (enlargeTrigger) {
              enlargeTrigger.dataset.enlargeurl = thumb.dataset.enlargedsource;
              enlargeTrigger.dataset.enlargetitle = thumb.dataset.imagetitle;
            }
            galleryThumbs.forEach(function (otherThumb) {
              if (otherThumb !== e.currentTarget && otherThumb.classList.contains('c-image-gallery__thumb--active')) {
                otherThumb.classList.remove('c-image-gallery__thumb--active');
              }
            });
            galleryText.innerHTML = '';
            // galleryText.classList.remove('active');

            Object.keys(text).forEach(function (key) {
              if (text[key]) {
                // galleryText.classList.add('active');
                galleryText.innerHTML += "<span>".concat(key, ": ").concat(text[key], "</span>");
              }
            });
            e.currentTarget.classList.add('c-image-gallery__thumb--active');
          });
        });
      }
    }
  }]);
  return ImageGallery;
}();
export { ImageGallery as default };